/*
 * main.js
 * Copyright (C) 2016 Adrian Perez <aperez@igalia.com>
 */
'use strict';

var TOUCH_TAP_TIMEOUT   = 200;  // Milliseconds.
var TOUCH_TAP_THRESHOLD = 20;

var TOUCHED_TIMEOUT     = 5000;  // Milliseconds.
var TOUCHED_CLASS_NAME  = "touch-hovered";

var classList = require("classlist");
var events = require("./events.js");

// Used in tap detection.
var touchStartX = -1;
var touchStartY = -1;
var touchCurrentX = -1;
var touchCurrentY = -1;
var touchTimerId = null;
var touchTimedOut = true;

function getTouchObject(e) {
	if (e.originalEvent && e.originalEvent.targetTouches) {
		return e.originalEvent.targetTouches[0];
	}
	if (e.targetTouches) {
		return e.targetTouches[0];
	}
	return e;
}

function onElementTouchStart(e) {
	var obj = getTouchObject(e);
	touchStartX = touchCurrentX = obj.pageX;
	touchStartY = touchCurrentY = obj.pageY;
	touchTimedOut = false;
	if (touchTimerId) clearTimeout(touchTimerId);
	touchTimerId = setTimeout(function() { touchTimedOut = true }, TOUCH_TAP_TIMEOUT);
}

function onElementTouchMove(e) {
	var obj = getTouchObject(e);
	touchCurrentX = obj.pageX;
	touchCurrentY = obj.pageY;
}

function onElementTouchEnd(e) {
	if (!touchTimedOut && Math.abs(touchCurrentX - touchStartX) <= TOUCH_TAP_THRESHOLD
			           && Math.abs(touchCurrentY - touchStartY) <= TOUCH_TAP_THRESHOLD)
	{
		var classes = classList(this);
		if (classes.contains(TOUCHED_CLASS_NAME)) {
			classes.remove(TOUCHED_CLASS_NAME);
		} else {
			classes.add(TOUCHED_CLASS_NAME);
			setTimeout(function() { classes.remove(TOUCHED_CLASS_NAME) }, TOUCHED_TIMEOUT);
			e.stopPropagation();
			e.preventDefault();
		}
	}
}

function wireHoverOnTouch(element) {
	events.add(element, "touchstart",  onElementTouchStart);
	events.add(element, "touchmove",   onElementTouchMove);
	events.add(element, "touchcancel", onElementTouchEnd);
	events.add(element, "touchend",    onElementTouchEnd);
}

function wireEvents() {
	var elements = document.getElementsByClassName("layout-box");
	for (var i = 0; i < elements.length; i++) {
		var element = elements[i];
		if (element.nodeName === "A") {
			wireHoverOnTouch(element);
		}
	}
}

function fixLinkTargets() {
	var l = document.links;
	var h = window.location.hostname;
	for (var i = 0; i < l.length; i++) {
		var e = document.links[i];
		if (e.hostname !== h && (e.target === undefined || e.target === "")) {
			console.log("Changing link: " + e.href);
			e.target = "_blank";
			if (e.rel !== undefined) {
				e.rel = "noopener";
			} else if (e.attributes !== undefined) {
				a.attributes["rel"] = "noopener";
			}
		}
	}
}

fixLinkTargets();
wireEvents();

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
ga('create', 'UA-89273308-1', 'auto');
ga('send', 'pageview');



//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = 2
// module chunks = 0